import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Bookmarks from "@/pages/Bookmarks";
import Admin from "@/pages/Admin";
import AdminSettings from "@/pages/AdminSettings";
import AdminTeam from "@/pages/AdminTeam";
import AdminAds from "@/pages/AdminAds";
import Search from "@/pages/Search";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Team from "@/pages/Team";
import Subscribe from "@/pages/Subscribe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPayments from "@/pages/AdminPayments";
import AdminPaymentQRs from "@/pages/AdminPaymentQRs";
import WhatsAppBubble from "@/components/WhatsAppBubble";

function AppShell() {
  const [breakingHeadlines, setBreakingHeadlines] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/articles?breaking=true&limit=10");
        setBreakingHeadlines(data.map((a) => ({ id: a.id, title: a.title })));
      } catch {}
    })();
  }, []);

  return (
    <Layout breakingHeadlines={breakingHeadlines}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/article/:id" element={<Article />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/bookmarks" element={<Bookmarks />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/team" element={<AdminTeam />} />
        <Route path="/admin/ads" element={<AdminAds />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/qrs" element={<AdminPaymentQRs />} />
        <Route path="/search" element={<Search />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/subscribe/success" element={<PaymentSuccess />} />
        <Route path="/subscribe/cancel" element={<PaymentCancel />} />
      </Routes>
      <WhatsAppBubble />
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <AppShell />
          <Toaster position="top-right" richColors closeButton />
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
